<style lang="less" scoped>
.product-normal{
  background-color: #fff;
  padding: 0 16px;
  .product-item{
    position: relative;
    display: flex;
    align-items: center;
    background-color: #fff;
    .product-total{
      position: absolute;
      right: 24px;
      top: 50%;
      transform: translateY(-50%);
      color: rgb(121, 125, 130);
    }
    .product-photo{
      margin: 15px 2.7vw 15px 0;
      background-color: rgb(248,248,248);
      img{
        height: 22.7vw;
        width: 22.7vw;
        background-color: rgb(248,248,248);
      }
    }
    .product-info{
      padding: 15px 15px 15px 0;
      height: 32vw;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      .product-name{
        font-size: 15px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
      .product-num{
        font-size: 13;
        color: rgb(189, 192,197);
        position: absolute;
        bottom: 15px;
        right: 15px;
      }
      .product-attribute{
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        font-size: 13px;
        color: rgb(121, 125, 130);
      }
      .product-price{
        font-size: 15px;
        color: #c03131;
        position: absolute;
        bottom: 15px;
      }
    }
  }
  .dividing-line{
    height: 0.5px;
    background-color: #d2d2d2;
  }
  .product-num-contrl{
    height: 57.5px;
    font-size: #4a4a4a;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>

<template>
  <div class="product-normal">
    <div class="product-item item">
      <div class="product-photo" ><img v-bind:src="imgUrl" alt=""></div>
      <div class="product-info">
        <div class="product-name">{{masterName}}</div>
        <div class="product-num" >&times;{{buyNumber}}</div>
        <div class="product-attribute" >{{skuMasterName}}</div>
        <div class="product-price" ><small class="icon-yen">&yen;</small>{{singlePrice | price}}</div>
      </div>
    </div>
    
    <div class="product-price"></div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import op from 'object-path'

export default {
  props: ['activeCode', 'activeDetail'],
  data() {
    return {

    }
  },
  components: {
  },
  computed: {
    ...mapState({
       skuInfo: state => state.pay.skuListData,
    }),
    needPay() {
      return this.singlePrice * this.buyNumber
    },
    buyNumber(){
      return this.skuInfo[0]?this.skuInfo[0].count:1
    },
    limitMinNumber() {
      return op(this.activeDetail).get('minCountPerOrder') || 1
    },
    limitMaxNumber() {
      return op(this.activeDetail).get('maxCountPerOrder') || 2
    },
    singlePrice() {
      return op(this.activeDetail).get('productInfo.skuList.0.price') || 0
    },
    masterName() {
      return op(this.activeDetail).get('productInfo.masterName') || ''
    },
    skuMasterName() {
      return op(this.activeDetail).get('productInfo.skuList.0.masterName') || ''
    },
    imgUrl() {
      return op(this.activeDetail).get('productInfo.skuList.0.imgUrls.0') || ''
    },
  },
  methods: {
    
  },
  mounted() {
  },
  watch: {
    
    needPay(newVal) {
      this.$store.commit('setTotalPrice', newVal)
    },
  }
}
</script>
